// ItemIconHelper.js - 装备/道具图标纹理 key 解析

/**
 * 由 item.id 得到预加载纹理 key（与 equipmentIcons.generated.js 一致）
 * @param {{ id?: string, name?: string }|null|undefined} item
 * @returns {string|null}
 */
export function getEquipmentIconKey(item) {
    if (!item?.id) {
        return item?.name ? `equipment_${item.name}` : null;
    }
    return `equipment_${item.id}`;
}

/**
 * 解析当前场景可用的装备图标 key（优先 id，兼容旧中文 name）
 * @param {Phaser.Scene} scene
 * @param {{ id?: string, name?: string }|null|undefined} item
 * @returns {string|null}
 */
export function resolveEquipmentIconKey(scene, item) {
    if (!item || !scene?.textures) {
        return null;
    }

    const candidates = [];
    if (item.id) {
        candidates.push(`equipment_${item.id}`);
    }
    if (item.name) {
        candidates.push(`equipment_${item.name}`);
    }

    for (const key of candidates) {
        if (scene.textures.exists(key)) {
            return key;
        }
    }
    return null;
}
